<template>
  <div class="teacher-course-index" v-loading="loading">
    <div class="model-header">
      <h3 class="user-title-main">Cập nhật khóa học</h3>
      <el-button @click="backModel" size="small" type="info" class="btn-create">Trở về</el-button>
    </div>
    <el-form label-position="top" :rules="rules" :model="modelData" ref="createModel">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="Thông tin" name="first">
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item prop="name" label="Tên khóa học" class="form-item">
                <el-input v-model="modelData.name" class="input-seach"></el-input>
              </el-form-item>
              <el-form-item prop="category_course_id" label="Danh mục khóa học" class="form-item">
                  <el-select v-model="modelData.category_course_id" filterable placeholder="Danh mục khóa học" class="input-select">
                      <el-option
                          v-for="item in lists.listCategoryCourse"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item prop="teacher_id" label="Giảng viên" class="form-item">
                <el-select v-model="modelData.teacher_id" filterable placeholder="Giảng viên" class="input-select">
                  <el-option
                    v-for="item in lists.listTeacher"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="video_youtube" label="Mã nhúng video Youtube" class="form-item">
                  <el-input v-model="modelData.video_youtube" :rows="5" type="textarea" class="input-seach"></el-input>
              </el-form-item>
              <el-form-item prop="slug" label="SEO Link" class="form-item">
                <el-input v-model="modelData.slug" class="input-seach"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item prop="price" label="Giá - Tự học" class="form-item">
                    <el-input type="age" v-model.number="modelData.price" class="input-seach" auto-complete="off">
                      <template slot="append">{{ modelData.price | vnd }}</template>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="price_online_class" label="Giá - Lớp online" class="form-item">
                    <el-input type="age" v-model.number="modelData.price_online_class" class="input-seach" auto-complete="off">
                      <template slot="append">{{ modelData.price_online_class | vnd }}</template>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="price_private_teacher" label="Giá - Học cùng giáo viên" class="form-item">
                    <el-input type="age" v-model.number="modelData.price_private_teacher" class="input-seach" auto-complete="off">
                      <template slot="append">{{ modelData.price_private_teacher | vnd }}</template>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="level" label="Cấp độ" class="form-item">
                    <el-select v-model="modelData.level" filterable  placeholder="Cấp độ" class="input-select">
                      <el-option
                        v-for="item in lists.listRank"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="price_brick" label="Giá gạch" class="form-item">
                    <el-input type="age" v-model.number="modelData.price_brick" class="input-seach" auto-complete="off">
                      <template slot="append">{{ modelData.price_brick | vnd }}</template>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="total_time_videos_txt" label="Tổng thời gian" class="form-item">
                    <el-input v-model="modelData.total_time_videos_txt" class="input-seach" auto-complete="off" placeholder="11:40 (phút)"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item prop="image" label="Ảnh khóa học">
                <el-upload
                  class="course-uploader"
                  :action="upload.url"
                  :headers="upload.headers"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :on-progress="handleAvatarProcess"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="modelData.image_path" :src="modelData.image_path" class="course-928">
                  <i v-else class="el-icon-plus course-uploader-icon"></i>
                  <div slot="tip" class="el-upload__tip">
                    <i class="fas fa-spinner fa-spin" v-if="upload.uploadProcess"></i>
                    Ảnh khóa học kích thước (800 * 450) có dung lượng tối đa là 2Mb
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>
           </el-row>
          <div>
            <el-form-item prop="content" label="Nội dung khóa học" v-if="canUpdate">
              <tinymce
                id="d1"
                v-model="modelData.content"
                :toolbar1="tinymce.toolbar1"
                :other_options="{ height: '300px', language_url: '/static/plugins/tinymce/vi_VN.js' }"></tinymce>
            </el-form-item>
            <el-form-item>
              <el-button
                :disable="!canSubmit"
                :loading="!canSubmit"
                type="warning"
                size="small"
                @click="submitForm('createModel')">Cập nhật</el-button>
              <el-button
                size="small"
                class="btn-back"
                @click="backModel">Trở về
              </el-button>
            </el-form-item>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Danh sách bài học" name="second">
          <div v-for="(item, index_1) in chapterLesson":key="index_1">
            <div class="main-term d-flex align-items-center justify-content-between">
                <div>
                    <span class="text">{{ item.name }}</span>
                </div>
                <div class="module-action">
                    <el-tooltip effect="dark" content="Sửa" placement="top">
                      <span @click="updateModelChapter(item)">
                        <i class="far fa-edit icon-update"></i>
                      </span>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="Xóa" placement="top">
                      <span @click="confirmDeleteModelChapter(item)">
                        <i class="far fa-trash-alt icon-delete"></i>
                      </span>
                    </el-tooltip>
                </div>
            </div>
            <div class="course-terms">
                <draggable
                    v-model="item.lessons"
                    v-bind="dragOptions"
                    @start="drag = true"
                    @end="drag = false"
                    :group="index_1"
                    @change="log"
                >
                    <div
                        class="item-child-2 d-flex flex-sm-row justify-content-between"
                        v-for="(item2) in item.lessons">
                        <span>
                            {{ item2.lesson_position }}. {{ item2.name }}
                        </span>
                        <div class="d-flex align-items-center">
                            <div class="module-testkit">
                                <span v-if="item2.test_kit_id > 0" class="sub-name">Đề {{ item2.test_kit_type_question_txt }}</span>
                                <el-switch
                                    v-if="item2.test_kit_id > 0"
                                    v-model="item2.status"
                                    active-color="#13ce66"
                                    inactive-color="#7f8c8d"
                                    @change="changeStatus(item2)">
                                </el-switch>
                            </div>
                            <div class="module-action">
                                <el-tooltip v-if="item2.test_kit_id > 0" effect="dark" content="Sửa" placement="top">
                                  <span @click="showTestKit(item2)">
                                    <i class="far fa-edit icon-update"></i>
                                  </span>
                                </el-tooltip>
                                <el-tooltip v-if="item2.test_kit_id == 0" effect="dark" content="Sửa" placement="top">
                                  <span @click="updateModelLesson(item2)">
                                    <i class="far fa-edit icon-update"></i>
                                  </span>
                                </el-tooltip>
                                <el-tooltip effect="dark" content="Xóa" placement="top">
                                    <span @click="confirmDeleteModelLesson(item2)">
                                        <i class="far fa-trash-alt icon-delete"></i>
                                    </span>
                                </el-tooltip>
                            </div>
                        </div>

                    </div>
                </draggable>
                <div class="mt-2 d-flex flex-column">
                    <span v-if="item.lessons.length > 0" class="description-guest">
                        Di chuyển thứ tự bài học tới vị trí bạn muốn
                    </span>
                    <div>
                        <el-button @click="addLesson(item.chapter_id)" size="small" type="info" class="btn-create">Thêm bài học</el-button>
                        <el-button @click="addTestKit(item.chapter_id)" size="small" type="info" class="btn-create">Thêm đề thi</el-button>
                    </div>
                </div>
            </div>
          </div>
          <div>
              <el-button @click="addChaper" size="small" type="info" class="btn-create">Thêm chương</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <!-- Cập nhật chương -->
    <el-dialog
      :close-on-click-modal="false"
      :title="'Cập nhật chương'"
      :visible.sync="dialogVisibleChapter"
      top="35vh"
      width="35%">
      <div>
        <el-input v-model="modelChapterUpdate.name" class="input-seach" auto-complete="off">

        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleChapter = false" size="small">Cancel</el-button>
        <el-button
          :disable="!canSubmit"
          :loading="!canSubmit"
          type="primary" @click="updateChaperToServer"  size="small">OK</el-button>
      </span>
    </el-dialog>
    <!-- Thêm mới đề thi -->
    <el-dialog
        :close-on-click-modal="false"
        :title="'Thêm mới đề thi'"
        :visible.sync="dialogVisibleLessonTestKitCreate"
        top="15vh"
        :width="isMobile()">
        <div>
          <el-form label-position="top" :rules="rulesTestKit" :model="modelLessonTestKitCreate" ref="createModelTestKit" @submit.native.prevent>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item prop="type_time" label="Kiểu đề thi" class="form-item">
                      <el-select v-model="modelLessonTestKitCreate.type_time" filterable placeholder="Kiểu đề thi" class="input-select">
                        <el-option
                          v-for="item in lists.listTypeTime"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item prop="time" label="Thời gian thi" class="form-item">
                      <el-input v-model="modelLessonTestKitCreate.time" class="input-seach input-seach-2">
                        <template slot="append">{{ modelLessonTestKitCreate.time }} phút</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="type_question" label="Loại đề thi" class="form-item">
                      <el-select v-model="modelLessonTestKitCreate.type_question" filterable placeholder="Loại đề thi" class="input-select">
                        <el-option
                          v-for="item in lists.listTypeQuesition"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item prop="score_success" label="Điểm đạt tối thiểu" class="form-item">
                      <el-select v-model="modelLessonTestKitCreate.score_success" filterable placeholder="Điểm đạt" class="input-select">
                        <el-option
                          v-for="item in lists.listScoreSuccess"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item prop="name" label="Tên đề thi" class="form-item">
                  <el-input v-model="modelLessonTestKitCreate.name" class="input-seach" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item>
              <el-button
                :disable="!canSubmit"
                :loading="!canSubmit"
                type="success"
                size="small"
                @click="submitFormCreateTestKit('createModelTestKit')">Lưu lại</el-button>
              <el-button
                size="small"
                class="btn-back"
                @click="dialogVisibleLessonTestKitCreate = false">Hủy
              </el-button>
            </el-form-item>
          </el-form>
        </div>
    </el-dialog>
    <!-- Cập nhật bài giảng -->
    <el-dialog
        :close-on-click-modal="false"
        :title="'Cập nhật bài giảng'"
        :visible.sync="dialogVisibleLessonUpdate"
        top="5vh"
        :width="isMobile()">
        <div>
            <el-form label-position="top" :rules="rulesLesson" :model="modelLessonUpdate" ref="updateModelLesson" @submit.native.prevent>
                <el-row :gutter="15">
                    <el-col :span="12">
                        <el-form-item prop="name" label="Tên khóa học" class="form-item">
                          <el-input v-model="modelLessonUpdate.name" class="input-seach"></el-input>
                        </el-form-item>
                        <el-form-item prop="time_video_txt" label="Thời gian video" class="form-item">
                          <el-input v-model="modelLessonUpdate.time_video_txt" class="input-seach"></el-input>
                        </el-form-item>
                        <el-form-item prop="link_video" label="Link video (mã Embemd của video Vimeo)" class="form-item">
                          <el-input v-model="modelLessonUpdate.link_video" :rows="5" type="textarea" class="input-seach"></el-input>
                        </el-form-item>
                        <div id="upload-container" class="text-center">
                          <button id="browseFile" ref="browseFile" class="btn btn-primary">Chọn File (Chỉ nhận file .mp4)</button>
                        </div>
                        <el-progress :percentage="percentage"></el-progress>
                    </el-col>
                    <el-col :span="12">
                        <div v-html="modelLessonUpdate.link_video" class="video-ebem"></div>
                    </el-col>
                </el-row>
                <div class="row">
                  <el-form-item prop="lesson_content" label="Nội dung bài học">
                    <tinymce
                      id="lesson_content"
                      v-model="modelLessonUpdate.lesson_content"
                      :toolbar1="tinymce.toolbar1"
                      :other_options="{ height: '300px', language_url: '/static/plugins/tinymce/vi_VN.js' }"></tinymce>
                  </el-form-item>
                  <el-form-item prop="lesson_document" label="Tài liệu bài học">
                    <tinymce
                      id="lesson_document"
                      v-model="modelLessonUpdate.lesson_document"
                      :toolbar1="tinymce.toolbar1"
                      :other_options="{ height: '200px', language_url: '/static/plugins/tinymce/vi_VN.js' }"></tinymce>
                  </el-form-item>
                  <label>
                    <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
                  </label>
                  <el-button v-on:click="submitFile()" size="mini" type="success">
                      <i class="fas fa-spinner fa-spin" v-if="uploadProcess"></i>
                      Gửi
                  </el-button>
                  <p>{{ link }}</p>
                </div>
              <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="warning"
                  size="small"
                  @click="submitFormUpdateLesson('updateModelLesson')">Cập nhật</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="dialogVisibleLessonUpdate = false">Đóng
                </el-button>
              </el-form-item>
            </el-form>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import ls from 'local-storage'
import tinymce from 'vue-tinymce-editor'
import draggable from 'vuedraggable'
export default {
  name: 'TeacherCourseCreate',
  props: {
      params: {
          type: Object,
          default: () => {
              return {};
          }
      },
      // courseID: {
      //     type: Number,
      //     default: 0
      // },
      tabCourseUpdate: {
          type: String,
          default: 'first'
      }
  },
  components: {
    tinymce,
    draggable
  },
  computed: {
      dragOptions() {
        return {
          animation: 200,
          group: "description",
          disabled: false,
          ghostClass: "ghost"
        };
      }
  },
  data () {
      return {
          drag: false,
          loading: false,
          canSubmit: true,
          canUpdate: true,
          activeName: 'first',
          status: true,

          // Phần upload chunk
          percentage: 0,
          link_video: '',
          resumableDB: 0,

          modelData: {

          },
          chapterLesson: {},

          // Update chương
          dialogVisibleChapter: false,
          modelChapterUpdate: {},

          // Phần đề thi
          dialogVisibleLessonTestKitCreate: false,
          modelLessonTestKitCreate: {
              name: '',
              course_id: '',
              chapter_id: '',
              time: 15,
              type_time: 1,
              type_question: 1,
              score_success: 6
          },

          dialogVisibleLessonTestKitUpdate: false,
          modelLessonTestKitUpdate: {

          },
          rulesTestKit: {
              name: [
                { required: true, message: 'Vui lòng nhập tên đề thi' },
                { min: 2, max: 191, message: 'Tên đề thi có chiều dài từ 2 tới 191 kí tự' }
              ],
              time: [
                { required: true, message: 'Vui lòng nhập thời gian thi' }
              ]
          },

          // Phần bài giảng:
          dialogVisibleLessonUpdate: false,
          modelLessonUpdate: {},
          rulesLesson: {},
          // FILE
          file: {},
          uploadProcess: false,
          link: '',

          lists: {
            listCategoryCourse: [
              {key: 0, value: 'Chọn lĩnh vực'}
            ],
            listTeacher: [
              {key: 0, value: 'Chọn giảng viên'}
            ],
            listUniversity: [
              {key: 0, value: 'Không thuộc trường nào'},
              {key: 1, value: 'Trường Học Viện Ngân Hàng'},
              {key: 2, value: 'Trường Kinh Tế Quốc Dân'}
            ],
            listRank: [
              {key: 0, value: 'Chưa xếp hạng'},
              {key: 1, value: 'Người mới học'},
              {key: 2, value: 'Trung bình'},
              {key: 3, value: 'Nâng cao'}
            ],
            listTypeCourse: [
              {key: 0, value: 'Khóa học kĩ năng'},
              {key: 1, value: 'Khóa học đào tạo'}
            ],
            listSchool: [],
            listLevel: [],
            listFacult: [],
            listSpecialized: [],
            listTypeTime: [
              {key: 1, value: 'Kiểm tra 15 phút'},
              {key: 12, value: 'Kiểm tra giữa môn học'},
              // {key: 13, value: 'Kiểm tra giữa môn'},
              {key: 14, value: 'Kiểm tra kết thúc môn'},
              {key: 15, value: 'Kiểm tra cuối ky'},
              {key: 16, value: 'Thi Tốt Nghiệp'},
              {key: 17, value: 'Khóa luận tốt nghiệp'},
              {key: 18, value: 'Kiểm tra đầu vào'},
              {key: 19, value: 'Kiểm tra cuối bài'},
              {key: 20, value: 'Kiểm tra đánh giá năng lực'},
              {key: 21, value: 'Đề thi lý thuyết'}
            ],
            listTypeQuesition: [
              {key: 1, value: 'Trắc nghiệm'},
              {key: 2, value: 'Tự luận'}
            ],
            listScoreSuccess: [
              {key: 0, value: '0 điểm'},
              {key: 0.5, value: '0,5 điểm'},
              {key: 1, value: '1 điểm'},
              {key: 1.5, value: '1.5 điểm'},
              {key: 2, value: '2 điểm'},
              {key: 2.5, value: '2.5 điểm'},
              {key: 3, value: '3 điểm'},
              {key: 3.5, value: '3.5 điểm'},
              {key: 4, value: '4 điểm'},
              {key: 4.5, value: '4.5 điểm'},
              {key: 5, value: '5 điểm'},
              {key: 5.5, value: '5.5 điểm'},
              {key: 6, value: '6 điểm'},
              {key: 6.5, value: '6.5 điểm'},
              {key: 7, value: '7 điểm'},
              {key: 7.5, value: '7.5 điểm'},
              {key: 8, value: '8 điểm'},
              {key: 8.5, value: '8.5 điểm'},
              {key: 9, value: '9 điểm'},
              {key: 9.5, value: '9.5 điểm'},
              {key: 10, value: '10 điểm'}
            ]
          },
          upload: {
            uploadProcess: false,
            url: process.env.API_URI + 'courses/upload',
            headers: {
              Authorization: ''
            }
          },
          tinymce: {
            toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
          },
          rules: {
              name: [
                { required: true, message: 'Vui lòng nhập tên khóa học' },
                { min: 2, max: 191, message: 'Tên khóa học có chiều dài từ 2 tới 191 kí tự' }
              ],
              price: [
                { required: true, message: 'Vui lòng nhập giá khóa học' },
                { type: 'number', message: 'Giá khóa học phải là kiểu số' }
              ],
              price_online_class: [
                { required: true, message: 'Vui lòng nhập giá khóa học' },
                { type: 'number', message: 'Giá khóa học phải là kiểu số' }
              ],
              price_private_teacher: [
                { required: true, message: 'Vui lòng nhập giá khóa học' },
                { type: 'number', message: 'Giá khóa học phải là kiểu số' }
              ],
              category_course_id: [
                { required: false, message: 'Vui lòng nhập lĩnh vực khóa học' }
              ],
              content: [
                { required: true, message: 'Vui lòng nhập mô tả khóa học' }
              ]
          }
      }
  },
  mounted() {
      this.configFilter();
      this.fetchListCategoryCourse()
      this.fetchModel()
      this.fetchChapterLesson()
      this.configUpload()
      this.fetchListTeacher()
  },
  methods: {
    configUploadChunk () {
      if (this.resumableDB == 1) {
        return;
      }
      let browseFile = $('#browseFile')
      let resumable = new Resumable({
        // target: 'http://cati-video.sh/api/video-6688/upload-91772837s72813821',
        target: 'https://video.cati.edu.vn/api/video-6688/upload-91772837s72813821',
        fileType: ['mp4'],
        headers: {
          'Accept': 'application/json'
        },
        testChunks: false,
        throttleProgressCallbacks: 1,
        chunkSize: 3 * 1024 * 1024
      })

      this.resumableDB = 1;

      resumable.assignBrowse(browseFile[0])
      let _this = this

      resumable.on('fileAdded', function (file, event) {
        _this.$notify({
          title: 'Đang tải',
          message: 'Đang tải file lên, vui lòng giữ nguyên trình duyệt',
          type: 'success',
          duration: 1500
        })
        resumable.upload()
      })

      resumable.on('fileProgress', function (file, event) {
        _this.updateProgress(Math.floor(file.progress() * 100))
      })

      resumable.on('fileSuccess', function (file, response) {
        _this.$notify({
          title: 'Thành công',
          message: 'Tải file thành công',
          type: 'success',
          duration: 1500
        })
        response = JSON.parse(response)
        _this.modelLessonUpdate.link_video = response.iframe_video
      })

      resumable.on('fileError', function (file, event) {
        console.log('fileError')
        _this.$notify({
          title: 'Thất bại',
          message: 'Tải file thất bại, vui lòng F5 và tải lại file',
          type: 'error',
          duration: 1500
        })
      })
    },
    updateProgress (t) {
      this.percentage = t
    },
      configFilter () {
          this.courseID = this.$route.params.course_id
          this.activeName                                = this.tabCourseUpdate;
      },
      // Cấu hình Upload
      configUpload () {
        const token = ls.get('authen', '')
        if (token) {
          this.upload.headers.Authorization = `Bearer ${token.access_token}`
        } else {
          this.upload.headers.Authorization = 'Bearer'
        }
      },
      backModel () {
        this.$router.push({name: 'courses-index'})
      },
      showTestKit (model) {
          this.$emit('selectTestkit', model);
          this.$emit('selectType', 'testkit');
      },
      handleClick () {

      },
      ...mapActions(['setBreadcrumb']),
      configBreadcrumb () {
        let breadcrumb = [
          { name: 'home-index', text: 'Trang chủ' },
          { name: 'courses-index', text: 'Khóa học' },
          { name: '1courses-update', text: this.modelData.name }
        ]
        this.setBreadcrumb(breadcrumb)
      },
      isMobile() {
          // detect mobile vuejs
          // https://newbedev.com/display-different-vuejs-components-for-mobile-browsers
          if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
              return '96%'
          } else {
              return '55%'
          }
      },
      fetchListCategoryCourse () {
        axios.get('category-courses', {params: {'status': 1, 'type': 0}}).then(response => {
          switch (response.code) {
            case 200:
              this.lists.listCategoryCourse = response.data
              break
            default:
              this.$notify.error({
                title: 'Error',
                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
              })
              break
          }
        })
      },
      // Fetch dữ liệu về giảng viên
      fetchListTeacher () {
        let data = {
          'status': 1,
          'limit': -1,
          'user_type': 2
        }
        axios.get('users', {params: data}).then(response => {
          switch (response.code) {
            case 200:
              this.lists.listTeacher = response.data
              break
            default:
              this.$notify.error({
                title: 'Error',
                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
              })
              break
          }
        })
      },
      fetchModel () {
          this.canSubmit = false
          axios.get('courses/' + this.courseID).then(response => {
            switch (response.code) {
              case 200:
                this.canSubmit = true
                this.modelData = response.data
                this.configBreadcrumb()
                break
              default:
                this.$notify.error({
                  title: 'Error',
                  message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
                })
                break
            }
          })
      },
      fetchChapterLesson () {
          axios.post('courses/get-chapter-lesson/' + this.courseID).then(response => {
            switch (response.code) {
              case 200:
                this.canSubmit = true
                this.chapterLesson = response.data.chapters
                break
              default:
                this.$notify.error({
                  title: 'Error',
                  message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
                })
                break
            }
          })
      },
      // Lưu dữ liệu
      submitForm (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.updateModel()
          } else {
            this.$notify({
              title: 'Lỗi dữ liệu nhập',
              message: 'Vui lòng kiểm tra lại thông tin',
              type: 'warning'
            })
            return false
          }
        })
      },
      updateModel () {
        this.canSubmit = false
        axios.put('courses/' + this.courseID, this.modelData).then(response => {
          this.canSubmit = true
          switch (response.code) {
            case 200:
              this.$notify({
                title: 'Thành công',
                message: 'Cập nhật khóa học thành công',
                type: 'success',
                duration: '1000'
              })
              break
            case 422:
              let er = response.data.errors
              let message = _.head(er[Object.keys(er)[0]])
              this.$notify({
                title: 'Có lỗi xảy ra',
                message: message,
                type: 'warning'
              })
              break
            default:
              this.$notify.error({
                title: 'Error',
                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
              })
              break
          }
        })
      },

      // Xử lý phần thêm chương
      addChaper () {
          this.$prompt('Nhập tên chương', 'Thêm chương mới', {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel'
          }).then(({ value }) => {
              this.addChaperToServer(value);
          }).catch(() => {

          });
      },
      addChaperToServer (name) {
          this.canSubmit = false
          let data = {
              'name': name,
              'course_id': this.courseID
          }
          axios.post('chapters/', data).then(response => {
              this.canSubmit = true
              switch (response.code) {
                  case 200:
                      this.$notify({
                          title: 'Thành công',
                          message: 'Thêm chương mới thành công',
                          type: 'success',
                          duration: '1000'
                      })
                      this.fetchChapterLesson();
                  break
                  case 422:
                      let er = response.data.errors
                      let message = _.head(er[Object.keys(er)[0]])
                  this.$notify({
                      title: 'Có lỗi xảy ra',
                      message: message,
                      type: 'warning'
                  })
                  break
              default:
                  this.$notify.error({
                      title: 'Error',
                      message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
                  })
                  break
            }
          })
      },
      confirmDeleteModelChapter (model) {
          this.$confirm('Xác nhận xóa chương: ' + model.name, 'Warning', {
            confirmButtonText: 'Đồng ý',
            cancelButtonText: 'Hủy',
            type: 'warning'
          }).then(() => {
            this.confirmDeleteModelChapterAction(model)
          }).catch(() => {

          })
      },
      confirmDeleteModelChapterAction (model) {
          axios.delete('chapters/' + model.chapter_id).then(response => {
            switch (response.code) {
              case 200:
                  this.$notify({
                      title: 'Thành công',
                      message: 'Xóa bản ghi thành công',
                      type: 'success'
                  })
                  this.fetchChapterLesson();
                break
              case 404:
                this.$notify({
                  title: 'Có lỗi xảy ra',
                  message: 'Không tìm thấy tài nguyên',
                  type: 'warning'
                })
                break
              case 422:
                let er = response.data.errors
                let message = _.head(er[Object.keys(er)[0]])
                this.$notify({
                  title: 'Có lỗi xảy ra',
                  message: message,
                  type: 'warning'
                })
                break
              default:
                this.$notify.error({
                  title: 'Error',
                  message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
                })
                break
            }
          })
      },
      updateModelChapter (model) {
          this.modelChapterUpdate = model;
          this.dialogVisibleChapter = true;
      },
      updateChaperToServer () {
          this.canSubmit = false
          let data = {
              'name': this.modelChapterUpdate.name,
              'course_id': this.courseID
          }
          axios.put('chapters/' + this.modelChapterUpdate.chapter_id, data).then(response => {
              this.canSubmit = true
              switch (response.code) {
                  case 200:
                      this.$notify({
                          title: 'Thành công',
                          message: 'Cập nhật chương mới thành công',
                          type: 'success',
                          duration: '1000'
                      })
                      this.fetchChapterLesson();
                      this.dialogVisibleChapter = false;
                  break
                  case 422:
                      let er = response.data.errors
                      let message = _.head(er[Object.keys(er)[0]])
                  this.$notify({
                      title: 'Có lỗi xảy ra',
                      message: message,
                      type: 'warning'
                  })
                  break
              default:
                  this.$notify.error({
                      title: 'Error',
                      message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
                  })
                  break
            }
          })
      },

      // Xử lý phần thêm bài học
      addLesson (chapter_id) {
          this.$prompt('Nhập tên bài học', 'Thêm bài học mới', {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel'
          }).then(({ value }) => {
              this.addLessonToServer(chapter_id, value);
          }).catch(() => {

          });
      },
      addLessonToServer (chapter_id, value) {
          this.canSubmit = false
          let data = {
              'name': value,
              'chapter_id': chapter_id
          }
          axios.post('lessons/', data).then(response => {
              this.canSubmit = true
              switch (response.code) {
                  case 200:
                      this.$notify({
                          title: 'Thành công',
                          message: 'Thêm bài học mới thành công',
                          type: 'success',
                          duration: '1000'
                      })
                      this.fetchChapterLesson();
                  break
                  case 422:
                      let er = response.data.errors
                      let message = _.head(er[Object.keys(er)[0]])
                  this.$notify({
                      title: 'Có lỗi xảy ra',
                      message: message,
                      type: 'warning'
                  })
                  break
              default:
                  this.$notify.error({
                      title: 'Error',
                      message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
                  })
                  break
            }
          })
      },
      confirmDeleteModelLesson (model) {
          this.$confirm('Xác nhận xóa bài học: ' + model.name, 'Warning', {
            confirmButtonText: 'Đồng ý',
            cancelButtonText: 'Hủy',
            type: 'warning'
          }).then(() => {
            this.confirmDeleteModelLessonAction(model)
          }).catch(() => {

          })
      },
      confirmDeleteModelLessonAction (model) {
          console.log(model);
          axios.delete('lessons/' + model.lesson_id).then(response => {
            switch (response.code) {
              case 200:
                  this.$notify({
                      title: 'Thành công',
                      message: 'Xóa bản ghi thành công',
                      type: 'success'
                  })
                  this.fetchChapterLesson();
                break
              case 404:
                this.$notify({
                  title: 'Có lỗi xảy ra',
                  message: 'Không tìm thấy tài nguyên',
                  type: 'warning'
                })
                break
              case 422:
                let er = response.data.errors
                let message = _.head(er[Object.keys(er)[0]])
                this.$notify({
                  title: 'Có lỗi xảy ra',
                  message: message,
                  type: 'warning'
                })
                break
              default:
                this.$notify.error({
                  title: 'Error',
                  message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
                })
                break
            }
          })
      },
      changeStatus (model) {
          let dataUpdate = {
            'status': model.status
          }
          axios.post('lessons/update-status/' + model.lesson_id, dataUpdate).then(response => {
            switch (response.code) {
              case 200:
                this.$notify({
                  title: 'Thành công',
                  message: 'Cập nhật trạng thái thành công',
                  type: 'success',
                  duration: '2000'
                })
                break
              default:
                this.fetchChapterLesson()
                break
            }
          })
      },

      // Upload Ảnh
      beforeAvatarUpload (file) {
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isLt2M) {
          this.$message.error('Ảnh khóa học có dung lượng ảnh tối đa là 2M')
        }
        return isLt2M
      },
      handleAvatarSuccess (response) {
        this.upload.uploadProcess = false
        if (response.code) {
          this.modelData.image = response.data.name
          this.modelData.image_path = response.data.path_sm
        }
      },
      handleAvatarProcess (event, file, fileList) {
        this.upload.uploadProcess = true
      },

      // Xử lý phần đề thi
      addTestKit (chapter_id) {
          this.dialogVisibleLessonTestKitCreate = true;
          this.modelLessonTestKitCreate.chapter_id = chapter_id;
          this.modelLessonTestKitCreate.course_id = this.courseID;
      },
      submitFormCreateTestKit (formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.submitFormCreateTestKitAction();
            } else {
              this.$notify({
                title: 'Lỗi dữ liệu nhập',
                message: 'Vui lòng kiểm tra lại thông tin',
                type: 'warning'
              })
              return false
            }
          })
      },
      submitFormCreateTestKitAction () {
        this.canSubmit = false
        axios.post('lessons/test-kit', this.modelLessonTestKitCreate).then(response => {
          this.canSubmit = true
          switch (response.code) {
            case 200:
              this.$notify({
                title: 'Thành công',
                message: 'Thêm thành công',
                type: 'success',
                duration: '1000'
              })
              this.fetchChapterLesson();
              this.dialogVisibleLessonTestKitCreate = false;
              this.modelLessonTestKitCreate.name = '';
              this.$refs['createModelTestKit'].resetFields();
              break
            case 422:
              let er = response.data.errors
              let message = _.head(er[Object.keys(er)[0]])
              this.$notify({
                title: 'Có lỗi xảy ra',
                message: message,
                type: 'warning'
              })
              break
            default:
              this.$notify.error({
                title: 'Error',
                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
              })
              break
          }
        })
      },

      // Xử lý phần bài giang
      updateModelLesson (model) {
        this.dialogVisibleLessonUpdate = true;
        setTimeout(() => {
          this.modelLessonUpdate = model;
          this.configUploadChunk();
          this.percentage = 0;
        }, 500)
      },
      submitFormUpdateLesson (formName) {
        this.canSubmit = false
        axios.put('lessons/' + this.modelLessonUpdate.lesson_id, this.modelLessonUpdate).then(response => {
          this.canSubmit = true
          switch (response.code) {
            case 200:
              this.$notify({
                title: 'Thành công',
                message: 'Cập nhật bài học thành công',
                type: 'success'
              })
              this.fetchChapterLesson();
              break
            case 422:
              let er = response.data.errors
              let message = _.head(er[Object.keys(er)[0]])
              this.$notify({
                title: 'Có lỗi xảy ra',
                message: message,
                type: 'warning'
              })
              break
            default:
              this.$notify.error({
                title: 'Error',
                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
              })
              break
          }
        })
      },

      handleFileUpload () {
        this.file = this.$refs.file.files[0]
      },
      async submitFile () {
        this.uploadProcess = true;
        let formData = new FormData()
        formData.append('file', this.file)
        formData.append('lesson_id', this.modelLessonUpdate.lesson_id)

        let response = await axios.post('lessons/upload-to-s3', formData)
        this.uploadProcess = false;
        if (response.code == 1) {
            this.link = response.data.path
            this.$notify({
                title: 'Thành công',
                message: 'Gửi file thành công',
                type: 'success'
            });
        } else {
            this.$notify({
                title: 'Có lỗi xảy ra',
                message: 'File không đúng định dạng hoặc dung lượng quá 2Mb',
                type: 'warning'
            });
        }
      },

    log: function(e) {
      let element = e.moved ? e.moved.element : e.removed.element
      let oldIndex = e.moved ? e.moved.oldIndex : e.removed.oldIndex
      let newIndex = e.moved ? e.moved.newIndex : this.newIndex

      // Tìm nhóm nào
      let prev_task_id = 0
      _.forEach(this.chapterLesson, (item, index) => {
        _.forEach(item.lessons, (task, index_task) => {
          if (task.lesson_id == element.lesson_id) {
            if (index_task > 0) {
              prev_task_id = item.lessons[index_task - 1].lesson_id
            }
          }
        });
      })
      let data = {
        'prev_task_id': prev_task_id
      }
      axios.post('lessons/update-position/' + element.lesson_id, data).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật vị trí thành công',
              type: 'success',
              duration: '1000'
            })
            this.fetchChapterLesson()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  },
  watch: {}
}
</script>
<style type="text/css" scoped>
  .main-term {
    background-color: #f2f2f2;
    margin-bottom: 10px;
    margin-top: 10px;
    padding: 5px 10px;
  }
  .main-term .text {
    font-weight: bold;
    font-size: 18px;
    margin-right: 40px;
  }

  .main-term .el-input {
    width: 250px;
    margin-left: 10px;
  }
  .course-terms {
    padding-left: 80px;
    padding-right: 10px;
    margin-bottom: 10px;
  }

  .item-child-2 {
    padding: 2px 0px 2px 5px;
    border: 1px solid rgba(0,0,0,.125);
    line-height: 30px;
  }
  .item-child-2:hover {
    background-color: #f8f8f8;
    cursor: pointer;
  }

  .description-guest {
    font-size: 10px;
    font-style: italic;
    margin-bottom: 7px;
    color: #373636;
  }

  .sub-name {
    font-size: 12px;
    margin-right: 10px;
  }

  .module-testkit {
    margin-right: 10px;
  }

  .video-ebem {
    overflow: hidden;
    max-height: 315px;
  }
  .video-ebem iframe {
    height: 355px !important;
    width: 100% !important;
  }
</style>

<style type="text/css">
  .mce-panel {
    /*width: 99.5% !important;*/
  }

  .course-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .course-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .course-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 160px;
    height: 115px;
    line-height: 115px !important;
    text-align: center;
  }
  .course-928 {
    width: 160px;
    height: 115px;
    object-fit: cover;
  }
  .video-ebem iframe {
    height: 355px !important;
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/courses/TeacherCourseUpdate.vue